export type ExpenseCategory =
  | 'travel'
  | 'meals'
  | 'lodging'
  | 'transportation'
  | 'office_supplies'
  | 'equipment'
  | 'software'
  | 'professional_dev'
  | 'client_entertainment'
  | 'other';

export type ExpenseStatus =
  | 'draft'
  | 'submitted'
  | 'approved'
  | 'rejected'
  | 'reimbursed';

export type ExpenseReportStatus =
  | 'draft'
  | 'submitted'
  | 'approved'
  | 'rejected'
  | 'reimbursed';

export interface Expense {
  id: string;
  originalId: string | null;
  version: number;
  isActive: boolean;
  employeeId: string;
  employeeName: string;
  category: ExpenseCategory;
  description: string;
  amount: number;
  currency: string;
  receiptUrl?: string;
  vendor: string;
  date: string;
  status: ExpenseStatus;
  approvedBy?: string;
  approvedAt?: string;
  reimbursedAt?: string;
  policyViolations: string[];
  reportId?: string;
  createdAt: string;
  createdBy: string;
  [key: string]: unknown;
}

export interface ExpenseReport {
  id: string;
  originalId: string | null;
  version: number;
  isActive: boolean;
  employeeId: string;
  employeeName: string;
  title: string;
  period: string;
  expenses: Expense[];
  totalAmount: number;
  status: ExpenseReportStatus;
  submittedAt?: string;
  approvedAt?: string;
  approvedBy?: string;
  rejectionReason?: string;
  createdAt: string;
  createdBy: string;
  [key: string]: unknown;
}

export interface CreateExpenseInput {
  employeeId: string;
  category: ExpenseCategory;
  description: string;
  amount: number;
  currency?: string;
  receiptUrl?: string;
  vendor: string;
  date: string;
}

export interface UpdateExpenseInput {
  category?: ExpenseCategory;
  description?: string;
  amount?: number;
  receiptUrl?: string;
  vendor?: string;
  date?: string;
}

export interface CreateExpenseReportInput {
  employeeId: string;
  title: string;
  period: string;
  expenseIds?: string[];
}

export const EXPENSE_CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  travel: 'Travel',
  meals: 'Meals',
  lodging: 'Lodging',
  transportation: 'Transportation',
  office_supplies: 'Office Supplies',
  equipment: 'Equipment',
  software: 'Software',
  professional_dev: 'Professional Development',
  client_entertainment: 'Client Entertainment',
  other: 'Other',
};

export const EXPENSE_CATEGORY_COLORS: Record<ExpenseCategory, string> = {
  travel: 'blue',
  meals: 'orange',
  lodging: 'violet',
  transportation: 'cyan',
  office_supplies: 'gray',
  equipment: 'teal',
  software: 'indigo',
  professional_dev: 'green',
  client_entertainment: 'pink',
  other: 'gray',
};
